import { useAppContext } from "../../context";
import { CheckIcon } from "../../icons";

export const ConfirmationScreen = () => {
  const { shopifyOrder } = useAppContext();

  return (
    <div className="tw-max-w-[822px] tw-mx-auto tw-text-center tw-bg-white tw-rounded md:tw-px-[190px] tw-px-10 tw-py-10 tw-mt-24 tw-text-blue">
      <div className="tw-flex tw-items-center tw-justify-center tw-text-[#00AEEF]">
        <CheckIcon />
      </div>
      <div className="tw-text-3xl tw-font-bold tw-mt-5">Thank you!</div>
      <div className="tw-text-xl tw-mt-5">
        <p>Your order ID is {shopifyOrder.name}.</p>
        <p className="tw-mt-5">
          If you have any questions about your quote, please do not hesitate to
          contact us on <span className="tw-font-medium">1-800-458-1289</span>{" "}
          or email us at{" "}
          <a className="tw-font-medium" href="mailto:sales@1clickenergy.com">
            sales@1clickenergy.com
          </a>
        </p>
        <p className="tw-mt-5">Your local sales rep will be in touch soon.</p>
      </div>
    </div>
  );
};
